import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../../services/api';

const Toppings = () => {
    const [toppings, setToppings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    
    const [formData, setFormData] = useState({
        id: null,
        name: '',
        is_active: true
    });

    useEffect(() => {
        fetchToppings();
    }, []);

    const fetchToppings = async () => {
        try {
            setLoading(true);
            const response = await api.get('/api/menu/toppings/');
            const data = response.data.results || response.data;
            setToppings(Array.isArray(data) ? data : []);
            setError(null);
        } catch (err) {
            console.error('Error fetching toppings:', err);
            setError('Error al cargar los toppings');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (formData.id) {
                await api.put(`/api/menu/toppings/${formData.id}/`, formData);
            } else {
                await api.post('/api/menu/toppings/', formData);
            }
            setShowModal(false);
            fetchToppings();
            resetForm();
        } catch (err) {
            console.error('Error saving topping:', err);
            alert('Error al guardar el topping');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este topping?')) {
            try {
                await api.delete(`/api/menu/toppings/${id}/`);
                fetchToppings();
            } catch (err) {
                console.error('Error deleting topping:', err);
                alert('Error al eliminar el topping');
            }
        }
    };

    const editTopping = (topping) => {
        setFormData({
            id: topping.id,
            name: topping.name,
            is_active: topping.is_active
        });
        setShowModal(true);
    };

    const resetForm = () => {
        setFormData({
            id: null,
            name: '',
            is_active: true
        });
    };

    if (loading) return <div style={{ padding: '2rem' }}>Cargando toppings...</div>;
    if (error) return <div style={{ padding: '2rem', color: 'red' }}>{error}</div>;

    return (
        <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                <h2 style={{ margin: 0, color: 'var(--primary-color)' }}>Gestión de Toppings</h2>
                <button 
                    onClick={() => { resetForm(); setShowModal(true); }}
                    style={{
                        padding: '0.75rem 1.5rem',
                        backgroundColor: 'var(--primary-color)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}
                >
                    <i className="bi bi-plus-circle"></i> Nuevo Topping
                </button>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#faf7f1', borderBottom: '1px solid #e6dfd3' }}>
                            <th style={{ padding: '1rem', textAlign: 'left', color: '#4a3f36' }}>Nombre</th>
                            <th style={{ padding: '1rem', textAlign: 'center', color: '#4a3f36' }}>Estado</th>
                            <th style={{ padding: '1rem', textAlign: 'right', color: '#4a3f36' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {toppings.map(topping => (
                            <tr key={topping.id} style={{ borderBottom: '1px solid #e6dfd3' }}>
                                <td style={{ padding: '1rem', fontWeight: '500' }}>{topping.name}</td>
                                <td style={{ padding: '1rem', textAlign: 'center' }}>
                                    <span style={{ 
                                        padding: '0.25rem 0.75rem', 
                                        borderRadius: '9999px', 
                                        fontSize: '0.75rem', 
                                        fontWeight: 'bold',
                                        backgroundColor: topping.is_active ? '#e0ebd8' : '#f7e5e0',
                                        color: topping.is_active ? '#3d5c37' : '#7a3a2a'
                                    }}>
                                        {topping.is_active ? 'Activo' : 'Inactivo'}
                                    </span>
                                </td>
                                <td style={{ padding: '1rem', textAlign: 'right' }}>
                                    <button 
                                        onClick={() => editTopping(topping)}
                                        style={{ background: 'none', border: 'none', color: '#6b4a33', cursor: 'pointer', marginRight: '1rem' }}
                                    >
                                        <i className="bi bi-pencil-square" style={{ fontSize: '1.25rem' }}></i>
                                    </button>
                                    <button 
                                        onClick={() => handleDelete(topping.id)}
                                        style={{ background: 'none', border: 'none', color: '#c0574a', cursor: 'pointer' }}
                                    >
                                        <i className="bi bi-trash" style={{ fontSize: '1.25rem' }}></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {toppings.length === 0 && (
                            <tr>
                                <td colSpan="3" style={{ padding: '2rem', textAlign: 'center', color: '#8a7d70' }}>
                                    No hay toppings creados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '12px', padding: '2rem',
                        width: '100%', maxWidth: '400px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
                    }}>
                        <h3 style={{ marginTop: 0, marginBottom: '1.5rem', color: '#1f1f1f' }}>
                            {formData.id ? 'Editar Topping' : 'Nuevo Topping'}
                        </h3>
                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '1rem' }}>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#4a3f36', fontWeight: '500' }}>Nombre</label>
                                <input 
                                    type="text" 
                                    name="name" 
                                    value={formData.name} 
                                    onChange={handleInputChange}
                                    required
                                    style={{
                                        width: '100%', padding: '0.75rem', borderRadius: '8px',
                                        border: '1px solid #d6ccbc', outline: 'none'
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input 
                                        type="checkbox" 
                                        name="is_active" 
                                        checked={formData.is_active}
                                        onChange={handleInputChange}
                                        style={{ marginRight: '0.5rem', width: '1rem', height: '1rem' }}
                                    />
                                    <span style={{ color: '#4a3f36', fontWeight: '500' }}>Activo</span>
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                                <button 
                                    type="button" 
                                    onClick={() => setShowModal(false)}
                                    style={{
                                        padding: '0.75rem 1.5rem', backgroundColor: '#e6dfd3',
                                        color: '#4a3f36', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '500'
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    type="submit"
                                    style={{
                                        padding: '0.75rem 1.5rem', backgroundColor: 'var(--primary-color)',
                                        color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '500'
                                    }}
                                >
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Toppings;
